module.exports = __webpack_public_path__ + "img/22_19.f17a0777.png";